import { Grid } from "@mui/material";
import { DBAnswerSpec } from "interfaces";
import { IFLEDoc } from "interfaces/db.interfaces/fle.interface";

import { useFormContext } from "react-hook-form";
import { DeleteButton } from "Components/IconButtons";
import { ContextSummary } from "./ContextSummary";

interface IProps {
  index: number;
  name: `contexts.${number}`;
  onDelete: (index: number) => void;
  canDelete: boolean;
}

export function SummaryContainer({ index, canDelete, ...props }: IProps) {
  const { watch, setValue, getValues } = useFormContext<IFLEDoc<DBAnswerSpec>>();

  function deleteContext() {
    return props.onDelete(index);
  }

  const context = watch(`contexts.${index}`);

  return (
    context && (
      <Grid container>
        <ContextSummary index={index} {...props} canDelete={canDelete} />
        {canDelete && (
          <Grid container item xs={1}>
            <DeleteButton onClick={deleteContext} />
          </Grid>
        )}
      </Grid>
    )
  );
}
